import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import {
  locales,
  mailTemplateAPI,
  platformSettings,
  PRODUCTION_URL,
  TINY_MCE_API_KEY
} from "../../api/api";
import {
  EMAIL_CONFIRMATION_MAIL_TEMPLATE,
  getEmailConfirmationMailTemplate,
  setMailTemplate,
  setMailTemplateSubject
} from "../../store/mailTemplatesSlice";
import { useEffect, useState } from "react";
import { Button, Col, Form, Input, Modal, Row, Tabs } from "antd";
import { tabsChange, updateTemplate } from "../../helpers/mailTemplatesHelpers";
import { Editor } from "@tinymce/tinymce-react";
import Loader from "../../components/Loader/Loader";
import React from "react";
import { setIsLoading } from "../../store/authSlice";
const { TabPane } = Tabs;
const EmailConfirmationMailTemplate = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation([
    "FA6-EmailConfirmationMailTemplate",
    "FA5-ExporterIncomingRequestMailTemplate",
    "utils"
  ]);
  const { setTitle } = useOutletContext();
  const { emailConfirmationMailTemplate } = useSelector((state) => state.mailTemplates);
  const { isLoading } = useSelector((state) => state.auth);
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [mailFrom, setMailFrom] = useState("");

  useEffect(() => {
    if (!emailConfirmationMailTemplate[locales[0]]) {
      dispatch(getEmailConfirmationMailTemplate(locales[0]));
    }
    platformSettings.getMailFrom().then((res) => setMailFrom(res.data.value));
  }, []);
  const saveMailFrom = () => {
    dispatch(setIsLoading(true));
    platformSettings
      .updateMailFrom(mailFrom)
      .then((res) => {
        setModalMessage(t("successfullySaved", { ns: "utils" }));
        setModalIsVisible(true);
      })
      .catch((e) => {
        setModalMessage(t("error", { ns: "utils" }));
        setModalIsVisible(true);
      })
      .finally(() => {
        dispatch(setIsLoading(false));
      });
  };
  useEffect(() => {
    setTitle(t("title"));
  }, [t, setTitle]);
  return (
    <>
      {modalIsVisible ? (
        <Modal
          visible={modalIsVisible}
          onCancel={() => {
            setModalIsVisible(false);
          }}
          footer={[
            <Button
              key="ok"
              className="btn btn_v2"
              onClick={() => {
                setModalIsVisible(false);
              }}
            >
              ОК
            </Button>
          ]}
        >
          <p>{modalMessage}</p>
        </Modal>
      ) : null}
      <Row>
        <Col sm={{ span: 24 }} xxl={{ span: 20 }} className={`regular_block`}>
          {isLoading && <Loader />}
          <Row style={{ marginBottom: 15 }} gutter={15}>
            <Col span={24}>
              <p style={{ marginBottom: 15 }}>
                {t("from", { ns: "FA6-EmailConfirmationMailTemplate" })}
              </p>
            </Col>
            <Col span={12}>
              <Input value={mailFrom} onChange={(e) => setMailFrom(e.target.value)} size="large" />
            </Col>
            <Col span={12}>
              <Button className="btn btn_v2" onClick={saveMailFrom}>
                {t("buttons.save", { ns: "utils" })}
              </Button>
            </Col>
          </Row>
          <div>
            <h5>{t("availableVariables")}</h5>
            <p>#FIRSTNAME - {t("FIRSTNAME")}</p>
            <p>#LASTNAME - {t("LASTNAME")}</p>
            <p>{t("BUTTON_EXAMPLE")}</p>
          </div>
          <Tabs
            defaultActiveKey={0}
            onChange={(key) => {
              tabsChange(
                key,
                emailConfirmationMailTemplate,
                dispatch,
                getEmailConfirmationMailTemplate
              );
            }}
          >
            {locales.map((el, i) => (
              <TabPane tab={el} key={i}>
                <Col span={12}>
                  <p className="mb-12">
                    {t("mailSubject", { ns: "FA5-ExporterIncomingRequestMailTemplate" })}
                  </p>
                  <Form>
                    <Form.Item>
                      <Input
                        value={emailConfirmationMailTemplate[locales[i]]?.subject}
                        onChange={(e) => {
                          dispatch(
                            setMailTemplateSubject({
                              mailTemplate: EMAIL_CONFIRMATION_MAIL_TEMPLATE,
                              lang: el,
                              subject: e.target.value
                            })
                          );
                        }}
                      />
                    </Form.Item>
                  </Form>
                </Col>
                <Editor
                  inline_styles={true}
                  apiKey={TINY_MCE_API_KEY}
                  plugins={["code"]}
                  value={emailConfirmationMailTemplate[locales[i]]?.template}
                  init={{
                    relative_urls: false,
                    remove_script_host: false,
                    document_base_url: PRODUCTION_URL
                  }}
                  onEditorChange={(content) => {
                    dispatch(
                      setMailTemplate({
                        mailTemplateName: EMAIL_CONFIRMATION_MAIL_TEMPLATE,
                        mailTemplateContent: content,
                        lang: locales[i]
                      })
                    );
                  }}
                />
                <div>
                  <h5 className="mt-50 mb-24">{t("mailTemplate")}</h5>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: emailConfirmationMailTemplate[locales[i]]?.template
                        ?.replace("#FIRSTNAME", t("FIRSTNAMEex"))
                        ?.replace("#LASTNAME", t("LASTNAMEex"))
                        ?.replace(
                          "#BUTTON_START#",
                          "<a style='padding: 14px 40px; background-color: #343543; color: #fff; display: flex; width: max-content;' href='#LINK'>"
                        )
                        ?.replace("#BUTTON_END#", "</a>")
                    }}
                  ></div>
                </div>
                <Button
                  onClick={() =>
                    updateTemplate(
                      locales[i],
                      emailConfirmationMailTemplate,
                      setModalMessage,
                      setModalIsVisible,
                      mailTemplateAPI.updateEmailConfirmationMailTemplate,
                      t,
                      dispatch
                    )
                  }
                  className="btn btn_v2 ml-auto mt-24"
                >
                  {t("buttons.save")}
                </Button>
              </TabPane>
            ))}
          </Tabs>
        </Col>
      </Row>
    </>
  );
};

export default EmailConfirmationMailTemplate;
